const member = [
  {
    id: 1,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '33.jpg',
    available: '14/02',
    rating: 5,
  },

  {
    id: 2,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '11.jpg',
    available: '14/02',
    rating: 5,
  },

  {
    id: 3,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '22.jpg',
    available: '14/02',
    rating: 5,
  },

  {
    id: 4,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '44.jpg',
    available: '14/02',
    rating: 5,
  },

  {
    id: 5,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '55.jpg',
    available: '14/02',
    rating: 5,
  },
  {
    id: 6,
    name: 'Vikasni Kannan',
    designation: 'Clinical Psychologist',
    img: '33.jpg',
    available: '14/02',
    rating: 5,
  },
];

export default member;
